import React, { memo as Memo, useMemo } from 'react'

//* HOC's
import { withDataContext } from 'context'

//* Components
import { Text, Icon, ShareIcon, Image, CustomLink, Container, Button, Page } from 'components/common'
import { SingleNews } from 'components/pages'

//* Config
import { config } from 'helpers'
import { useRouter } from 'next/router'

//* Style
import NewsIndividualStyle from 'styles/pages/NewsIndividualStyle'

const Single = Memo(({ pageParams, selectedLang, ...props }) => {
    const router = useRouter()

    const url = useMemo(() => process.env.host + router.asPath, [router])
    const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`
    const twitterUrl = `https://twitter.com/intent/tweet?url=${url}`
    const linkedinUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${url}`

    const singleNews = useMemo(
        () => props[pageParams?.singleType]?.[router.query.slug]?.[selectedLang],
        [props?.[pageParams?.singleType], router, selectedLang]
    )

    const storeNews = useMemo(() => {
        return singleNews?.relatedNews.map((i, k) => {
            return (
                <SingleNews
                    className={`type-${Math.floor(Math.random() * 3) + 1}`}
                    url={i.slug}
                    key={k}
                    image={i.featured_image}
                    title={i.title}
                    date={i.date}
                />
            )
        })
    }, [singleNews])

    function copyToClipboard() {
        const el = document.createElement('input')
        el.value = window.location.href
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
    }

    return singleNews ? (
        <NewsIndividualStyle className='single-news'>
            <Page meta={singleNews.news.meta}>
                <Container>
                    <CustomLink className='back-btn' url='/news'>
                        <Icon className='icon-arrowRight' />
                        <Text tag={'p'} className={'pM NotoSansRegular uppercase'} text={'BackToNews'} />
                    </CustomLink>
                    <div className='top FlexBox'>
                        <div className='infos FlexBoxColumn'>
                            <Text tag={'h4'} className={'h4 GHEAMariamRegular'} text={singleNews.news.title} />
                            <Text tag={'p'} className={'date pL NotoSansRegular'} text={singleNews.news.date} />
                            <div className='social FlexBoxColumn'>
                                <Text tag={'p'} className={'pL NotoSansRegular'} text={'share'} />
                                <div className='cont FlexBox'>
                                    <ShareIcon target={true} className={'icon-facebook'} url={facebookUrl} />
                                    <ShareIcon target={true} className={'icon-twitter'} url={twitterUrl} />
                                    <ShareIcon target={true} className={'icon-linkedin'} url={linkedinUrl} />
                                    <Icon onClick={() => copyToClipboard()} className={'icon-copy cursorPointer'} />
                                </div>
                            </div>
                        </div>
                        <Image src={singleNews.news.featured_image} alt='featured_Image' />
                    </div>
                    <div className='content' dangerouslySetInnerHTML={{ __html: singleNews.news.description }} />
                    {singleNews?.relatedNews.length > 0 && <Text tag={'h3'} className={'related-title h3 GHEAMariamBold uppercase'} text={'readNext'} />}
                </Container>
                {singleNews?.relatedNews.length > 0 && (
                    <>
                        <div className='related FlexBox'>{storeNews}</div>
                        <Button text={'SeeMoreNews'} link={config.routes.news.path} btnAnimation={true} />
                    </>)}
            </Page>
        </NewsIndividualStyle>
    ) : null
})

export default withDataContext(Single, [config.routes.singleNews.singleType])
